function injectStyle (context) {
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":false,\"minimize\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b380b312\",\"scoped\":true,\"sourceMap\":false}!sass-loader?{\"data\":\"// Due to current Vue configuration paths has to be relative to root directory\\n@import 'src/assets/sass/vars';\\n@import 'src/assets/sass/mixins';\\n\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PersonBox.vue")
}
/* script */
export * from "!!cache-loader?{\"cacheDirectory\":\"C:\\\\Users\\\\nowak\\\\Github\\\\swawa-frontend\\\\node_modules\\\\.cache\\\\cache-loader\"}!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PersonBox.vue"
import __vue_script__ from "!!cache-loader?{\"cacheDirectory\":\"C:\\\\Users\\\\nowak\\\\Github\\\\swawa-frontend\\\\node_modules\\\\.cache\\\\cache-loader\"}!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PersonBox.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b380b312\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PersonBox.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b380b312"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/containers/Team/PersonBox.vue
// module id = null
// module chunks = 